import {Component, Input, OnInit} from '@angular/core';

export interface TractorsProximity {
  domainID: number;
  domainName: string;
  data: {
    tractor: string;
    distance: number;
    field: string | null
  }[];
}

@Component({
  selector: 'app-tractors-proximity-widget',
  templateUrl: './tractors-proximity-widget.component.html',
  styleUrls: ['./tractors-proximity-widget.component.scss']
})
export class TractorsProximityWidgetComponent implements OnInit {

  @Input()
  data: TractorsProximity[];

  constructor() {
  }

  ngOnInit(): void {
  }

  onToolbarPreparing(e: any) {
    e.toolbarOptions.items.unshift({
      cssClass: 'dashboard-grid-header-title',
      location: 'center',
      widget: 'dxButton',
      template: 'Proximité corps de ferme',
    });
  }

}
